/**
 * 모델
 * @window w_tb_e101w
 * @category 유지보수계약현황
 */
import { computed } from 'mobx';

export class SiteModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 사업장명
   *
   * **data type** varchar(100)
   */
  spjangnm: string;

  /**
   * No
   *
   * **data type** varchar(?)
   */
  no: number;

  /**
   * 시작일자
   *
   * **data type** varchar(8)
   */
  stdate: string;

  /**
   * 만료일자
   *
   * **data type** varchar(8)
   */
  enddate: string;

  /**
   * 담당자코드
   *
   * **data type** varchar(10)
   */
  perid: string;

  /**
   * 담당자
   *
   * **data type** varchar(30)
   */
  pernm: string;

  /**
   * 회사구분
   *
   * **data type** varchar(3)
   */
  wkactcd: string;

  /**
   * 회사구분
   *
   * **data type** varchar(3)
   */
  wkactnm: string;

  /**
   * 현장코드
   *
   * **data type** varchar(15)
   */
  actcd: string;

  /**
   * 현장명
   *
   * **data type** varchar(100)
   */
  actnm: string;

  /**
   * 호기코드
   *
   * **data type** varchar(3)
   */
  equpcd: string;

  /**
   * 호기명
   *
   * **data type** varchar(100)
   */
  equpnm: string;

  /**
   * 최초설치년도
   *
   * **data type** varchar(8)
   */
  yyyymm: string;

  /**
   * 년수
   *
   * **data type** varchar(8)
   */
  gigan: string;

  /**
   * 설치년도
   *
   * **data type** varchar(8)
   */
  yyyymm2: string;

  /**
   * 년수
   *
   * **data type** varchar(8)
   */
  gigan2: string;

  /**
   * 정밀검사(회)
   *
   * **data type** varchar(?)
   */
  gubun002: string;

  /**
   * 계약구분
   *
   * **data type** varchar(2)
   */
  contg: string;

  /**
   * 계약분류
   *
   * **data type** varchar(10)
   */
  contgubun: string;

  /**
   * 대당금액
   *
   * **data type** varchar(?)
   */
  monamt: string;

  /**
   * 운행층수
   *
   * **data type** varchar(?)
   */
  number: string;

  /**
   * 보수업체
   *
   * **data type** varchar(200)
   */
  bosunm: string;

  /**
   * 현장담당자
   *
   * **data type** varchar(?)
   */
  actpernm: string;

  /**
   * 전화번호
   *
   * **data type** varchar(?)
   */
  tel: string;

  /**
   * 주소
   *
   * **data type** varchar(100)
   */
  address: string;

  /**
   * 상세주소
   *
   * **data type** varchar(100)
   */
  address2: string;

  /**
   * 제작
   *
   * **data type** varchar(200)
   */
  jejak: string;

  /**
   * 모델
   *
   * **data type** varchar(20)
   */
  mdnm: string;

  /**
   * 속도
   *
   * **data type** varchar(3)
   */
  speed: string;

  /**
   * 점검기종
   *
   * **data type** varchar(30)
   */
  evnm: string;

  /**
   * 분류
   *
   * **data type** varchar(20)
   */
  classnm: string;

  /**
   * 인화물구분
   *
   * **data type** varchar(1)
   */
  class2: string;

  /**
   * 수주여부
   *
   * **data type** varchar(1)
   */
  ordcnt: number;

  /**
   * 대당금액
   *
   * **data type** varchar(1)
   */
  daeamt: string;

  /**
   * 총계
   *
   * **data type** varchar(1)
   */
  total: string;

  /**
   * 운행종료일
   *
   * **data type** varchar(8)
   */
  kcenddate: string;

  /**
   * 최종검사일
   *
   * **data type** varchar(8)
   */
  totkcdate: string;

  /**
   * 관리대수
   *
   * **data type** varchar(8)
   */
  qty: string;

  /**
   * 부서명
   *
   * **data type** varchar(8)
   */
  divinm: string;

  /**
   * 계약자명
   *
   * **data type** varchar(8)
   */
  contpernm: string;

  /**
   * 청구주기
   *
   * **data type** varchar(8)
   */
  deljugi: string;

  /**
   * 계약금액
   *
   * **data type** varchar(8)
   */
  amt: string;

  /**
   * 지역명
   *
   * **data type** varchar(8)
   */
  areanm: string;

  /**
   * 계약서
   *
   * **data type** varchar(8)
   */
  picflag: string;

  /**
   * 건물용도
   *
   * **data type** varchar(8)
   */
  bildyd: string;

  /**
   * 매출구분
   *
   * **data type** varchar(8)
   */
  gubun: string;

  /**
   * 매출구분
   *
   * **data type** varchar(8)
   */
  mgubun: string;

  /**
   * 접수일자
   *
   * **data type** varchar(8)
   */
  recedate: string;

  /**
   * 계약일자
   *
   * **data type** varchar(8)
   */
  contdate: string;

  /**
   * 년차
   *
   * **data type** varchar(8)
   */
  yy: string;

  /**
   * 증빙구분
   *
   * **data type** varchar(8)
   */
  taxflag: string;

  /**
   * 세금구분
   *
   * **data type** varchar(8)
   */
  taxgubun: string;

  /**
   * 부가세포함
   *
   * **data type** varchar(8)
   */
  addyn: string;

  /**
   * 청구서발행일
   *
   * **data type** varchar(8)
   */
  dedate: string;

  /**
   * 청구서발행일
   *
   * **data type** varchar(8)
   */
  jirogubun: string;

  /**
   * 휴대폰번호
   *
   * **data type** varchar(8)
   */
  hp: string;

  /**
   * 우편번호
   *
   * **data type** varchar(8)
   */
  zipcode: string;

  /**
   * 거래처코드
   *
   * **data type** varchar(8)
   */
  cltcd: string;

  /**
   * 우편번호
   *
   * **data type** varchar(8)
   */
  cltnm: string;

  /**
   * 당월청구금액
   *
   * **data type** varchar(8)
   */
  nowamt: string;

  /**
   * 개월
   *
   * **data type** varchar(8)
   */
  month: string;

  /**
   * 총년
   *
   * **data type** varchar(8)
   */
  yy_total: string;

  /**
   *  총개월
   *
   * **data type** varchar(8)
   */
  month_total: string;

  /**
   *  최초시작일자
   *
   * **data type** varchar(8)
   */
  stdate_total: string;

  /**
   * 신규인지
   *
   * **data type** varchar(1)
   */
  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.spjangnm = data.spjangnm || '';
    this.no = data.no || 0;
    this.stdate = data.stdate || '';
    this.enddate = data.enddate || '';
    this.perid = data.perid || '';
    this.pernm = data.pernm || '';
    this.wkactcd = data.wkactcd || '';
    this.wkactnm = data.wkactnm || '';
    this.actcd = data.actcd || '';
    this.actnm = data.actnm || '';
    this.equpcd = data.equpcd || '';
    this.equpnm = data.equpnm || '';
    this.yyyymm = data.yyyymm || '';
    this.gigan = data.gigan || '';
    this.yyyymm2 = data.yyyymm2 || '';
    this.gigan2 = data.gigan2 || '';
    this.gubun002 = data.gubun002 || '';
    this.contg = data.contg || '';
    this.contgubun = data.contgubun || '';
    this.monamt = data.monamt || '';
    this.number = data.number || '';
    this.bosunm = data.bosunm || '';
    this.actpernm = data.actpernm || '';
    this.tel = data.tel || '';
    this.address = data.address || '';
    this.address2 = data.address2 || '';
    this.jejak = data.jejak || '';
    this.mdnm = data.mdnm || '';
    this.speed = data.speed || '';
    this.evnm = data.evnm || '';
    this.classnm = data.classnm || '';
    this.class2 = data.class2 || '';
    this.no = data.no || '';
    this.ordcnt = data.ordcnt || 0;
    this.daeamt = data.daeamt || '';
    this.total = data.total || '';
    this.kcenddate = data.kcenddate || '';
    this.totkcdate = data.totkcdate || '';
    this.qty = data.qty || '';
    this.divinm = data.divinm || '';
    this.contpernm = data.contpernm || '';
    this.deljugi = data.deljugi || '';
    this.amt = data.amt || '';
    this.picflag = data.picflag || '';
    this.areanm = data.areanm || '';
    this.bildyd = data.bildyd || '';
    this.gubun = data.gubun || '';
    this.mgubun = data.mgubun || '';
    this.recedate = data.recedate || '';
    this.contdate = data.contdate || '';
    this.yy = data.yy || '';
    this.taxgubun = data.taxgubun || '';
    this.taxflag = data.taxflag || '';
    this.addyn = data.addyn || '';
    this.dedate = data.dedate || '';
    this.jirogubun = data.jirogubun || '';
    this.hp = data.hp || '';
    this.zipcode = data.zipcode || '';
    this.cltcd = data.cltcd || '';
    this.cltnm = data.cltnm || '';
    this.nowamt = data.nowamt || '';
    this.month = data.month || '';
    this.yy_total = data.yy_total || '';
    this.month_total = data.month_total || '';
    this.stdate_total = data.stdate_total || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
